<template>
  <div
    class="flex items-center gap-1 rounded px-1 py-0.5 cursor-pointer hover:opacity-80 transition-opacity bg-white dark:bg-[#1C2128] border"
    :class="task.is_overdue ? 'border-red-300 dark:border-red-800' : 'border-gray-200 dark:border-gray-700'"
    @click.stop="emit('open', task)"
  >
    <button
      type="button"
      @click.stop="emit('toggle', task)"
      class="flex-shrink-0 w-2.5 h-2.5 rounded-full border-2 flex items-center justify-center"
      :style="{
        backgroundColor: isDone ? (task.color_css_code || '#2563eb') : 'transparent',
        borderColor: task.color_css_code || '#2563eb',
      }"
      :aria-label="isDone ? 'Mark as not done' : 'Mark as done'"
    ></button>
    <span
      class="text-[10px] font-medium truncate"
      :class="isDone ? 'text-gray-400 dark:text-gray-500 line-through' : 'text-gray-700 dark:text-gray-200'"
    >{{ task.title }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({ task: { type: Object, required: true } })
const emit = defineEmits(['open', 'toggle'])

const isDone = computed(() => props.task.status === 'completed')
</script>
